export const calculateSum = (array, property) => {
  let sum = 0;

  array.forEach(element => {
    sum += element[property];
  });

  return sum;
}

export const convertMoney = (value) => {
  let number = value?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") + ",00";
  return number
}